import { render } from "./NavBarTopNew.vue?vue&type=template&id=de931d36&scoped=true"
import script from "./NavBarTopNew.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarTopNew.vue?vue&type=script&setup=true&lang=js"

import "./NavBarTopNew.vue?vue&type=style&index=0&id=de931d36&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de931d36"],['__file',"src/components/app/nav/NavBarTopNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de931d36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de931d36', __exports__)) {
    api.reload('de931d36', __exports__)
  }
  
  module.hot.accept("./NavBarTopNew.vue?vue&type=template&id=de931d36&scoped=true", () => {
    api.rerender('de931d36', render)
  })

}


export default __exports__